import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, FileText, Search, Trash2, Users } from "lucide-react";

import { useAuth } from "../../../context/AuthContext";
import { useFuncion } from "../../../context/FuncionContext";
import LoadingSpinner from "../../LoadingSpinner";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const styles = `
.essm-overlay{position:fixed;inset:0;background:rgba(15,23,42,.52);z-index:1200;display:flex;align-items:center;justify-content:center;padding:18px}
.essm-modal{width:min(1120px,96vw);max-height:92vh;background:#fff;border-radius:18px;box-shadow:0 24px 80px rgba(15,23,42,.28);overflow:hidden;display:flex;flex-direction:column}
.essm-head{padding:18px 20px;border-bottom:1px solid #e5e7eb;background:linear-gradient(180deg,#f8fafc,#fff)}
.essm-top{display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap}
.essm-titleWrap{display:flex;align-items:center;gap:12px;min-width:0}
.essm-icon{width:44px;height:44px;border-radius:14px;background:#e0f2fe;color:#0369a1;display:flex;align-items:center;justify-content:center}
.essm-title{margin:0;font-size:1.25rem;font-weight:900;color:#111827}
.essm-meta{display:flex;align-items:center;gap:8px;flex-wrap:wrap;color:#64748b;font-size:.88rem;margin-top:4px}
.essm-chip{display:inline-flex;align-items:center;gap:6px;border:1px solid #e5e7eb;background:#f8fafc;border-radius:999px;padding:5px 10px;font-weight:800;color:#334155}
.essm-close{background:transparent;border:0;font-size:1.5rem;cursor:pointer;color:#94a3b8;padding:4px 8px;border-radius:8px}
.essm-close:hover{background:#f1f5f9;color:#475569}
.essm-toolbar{display:flex;justify-content:space-between;gap:12px;align-items:center;flex-wrap:wrap;padding:14px 20px;border-bottom:1px solid #eef2f7}
.essm-search{position:relative;min-width:min(420px,100%);flex:1}
.essm-searchIcon{position:absolute;left:12px;top:50%;transform:translateY(-50%);color:#94a3b8}
.essm-input{width:100%;border:1px solid #dbe3ef;border-radius:12px;padding:10px 12px 10px 38px;font-size:.95rem;outline:none}
.essm-input:focus{border-color:#2563eb;box-shadow:0 0 0 3px rgba(37,99,235,.12)}
.essm-actions{display:flex;gap:10px;align-items:center;flex-wrap:wrap}
.essm-btn{border:1px solid #dbe3ef;background:#fff;color:#334155;border-radius:12px;padding:10px 14px;font-weight:850;display:inline-flex;gap:8px;align-items:center;cursor:pointer}
.essm-btn:hover:not(:disabled){background:#f8fafc}
.essm-btn:disabled{opacity:.55;cursor:not-allowed}
.essm-btn.primary{background:#16a34a;border-color:#16a34a;color:#fff}
.essm-btn.primary:hover:not(:disabled){background:#15803d}
.essm-btn.danger{color:#b91c1c;border-color:#fecaca;background:#fff5f5}
.essm-body{padding:16px 20px;overflow:auto;min-height:220px}
.essm-bulk{display:flex;gap:10px;align-items:center;flex-wrap:wrap;margin-bottom:14px}
.essm-empty{border:1px dashed #cbd5e1;background:#f8fafc;color:#64748b;border-radius:14px;padding:18px;font-weight:750}
.essm-tableWrap{overflow:auto;border:1px solid #e5e7eb;border-radius:14px}
.essm-table{width:100%;border-collapse:collapse;min-width:860px}
.essm-table th{font-size:.73rem;text-transform:uppercase;color:#64748b;background:#f8fafc;text-align:left;padding:11px;border-bottom:1px solid #e5e7eb}
.essm-table td{padding:12px 11px;border-bottom:1px solid #eef2f7;vertical-align:middle}
.essm-table tr:last-child td{border-bottom:0}
.essm-student{display:flex;gap:10px;align-items:center;min-width:0}
.essm-avatar{width:38px;height:38px;border-radius:999px;background:#dbeafe;color:#1d4ed8;display:flex;align-items:center;justify-content:center;font-weight:950;flex:0 0 auto}
.essm-name{font-weight:900;color:#111827}
.essm-sub{color:#64748b;font-size:.84rem}
.essm-doc{color:#94a3b8;font-size:.78rem;margin-top:2px}
.essm-date{display:inline-flex;border-radius:999px;background:#eef2ff;color:#3730a3;padding:5px 10px;font-weight:850;font-size:.82rem}
.essm-origin{display:inline-flex;border-radius:999px;background:#f1f5f9;color:#475569;padding:5px 10px;font-weight:850;font-size:.82rem}
.essm-switch{width:42px;height:24px;border-radius:999px;border:0;padding:3px;display:inline-flex;align-items:center;cursor:pointer;background:#cbd5e1}
.essm-switch.on{background:#16a34a;justify-content:flex-end}
.essm-thumb{width:18px;height:18px;border-radius:999px;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,.2)}
.essm-iconBtn{border:1px solid #fecaca;background:#fff5f5;color:#b91c1c;border-radius:10px;padding:8px;display:inline-flex;cursor:pointer}
.essm-foot{display:flex;justify-content:space-between;gap:12px;align-items:center;flex-wrap:wrap;padding:14px 20px;border-top:1px solid #e5e7eb;background:#f8fafc}
.essm-select{border:1px solid #dbe3ef;border-radius:10px;padding:7px 9px;background:#fff}
.essm-addPanel{border-top:1px solid #e5e7eb;background:#fbfdff;padding:16px 20px;display:grid;gap:12px}
.essm-note{border:1px solid #dbeafe;background:#eff6ff;color:#1d4ed8;border-radius:12px;padding:10px 12px;font-weight:800}
.essm-picks{display:flex;gap:8px;flex-wrap:wrap}
.essm-pill{display:inline-flex;gap:8px;align-items:center;border:1px solid #dbe3ef;background:#fff;border-radius:999px;padding:6px 10px;font-weight:850}
.essm-pill button{border:0;background:transparent;cursor:pointer;color:#64748b}
.essm-available{display:grid;gap:8px;max-height:320px;overflow:auto}
.essm-option{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;padding:12px 14px;border-radius:14px;border:1px solid #e5e7eb;background:#fff;cursor:pointer;text-align:left}
.essm-option:disabled{opacity:.55;cursor:not-allowed}
.essm-optionLeft{display:flex;align-items:center;gap:10px;min-width:0}
@media(max-width:720px){.essm-overlay{padding:8px;align-items:stretch}.essm-modal{width:100%;max-height:100%;border-radius:14px}.essm-search{min-width:100%}.essm-actions{width:100%}.essm-btn{flex:1;justify-content:center}}
`;

const normalizeText = (s = "") =>
  String(s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const formatTimeShort = (value) => {
  if (!value) return "--:--";
  return String(value).slice(0, 5);
};

const formatStudentEnrollDate = (value) => {
  if (!value) return "--";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
  return date.toLocaleDateString("es-EC", { day: "2-digit", month: "2-digit", year: "numeric" });
};

const getStudentDisplayName = (student = {}) => {
  const full = `${student?.nombres || ""} ${student?.apellidos || ""}`.trim();
  return full || student?.nombre || student?.email || `Estudiante ${student?.id || ""}`.trim();
};

const getInitials = (student = {}) => {
  const full = getStudentDisplayName(student);
  return full
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("") || "?";
};

const canAddStudentsFor = (schedule) => {
  const capacity = Number(schedule?.cupos_disponibles || 0);
  const occupied = Number(schedule?.cupos_ocupados || schedule?.estudiantes_agendados || 0);
  return !capacity || occupied < capacity;
};

const runPool = async (items, worker, concurrency = 4) => {
  const queue = [...items];
  const results = [];
  const runners = Array.from({ length: Math.max(1, concurrency) }, async () => {
    while (queue.length) {
      const item = queue.shift();
      try {
        results.push({ ok: true, item, value: await worker(item) });
      } catch (error) {
        results.push({ ok: false, item, error });
      }
    }
  });
  await Promise.all(runners);
  return results;
};

export default function ExamScheduleStudentsModal({
  open,
  schedule,
  onClose,
  onChanged,
  title = "Estudiantes Inscritos",
}) {
  const {
    fetchExamStudents,
    fetchAvailableStudents,
    addStudentToExam,
    removeStudentFromExam,
    setStudentExamEnabled,
  } = useFuncion();
  const { user } = useAuth();

  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [selectedIds, setSelectedIds] = useState(() => new Set());
  const [studentBusy, setStudentBusy] = useState(() => new Set());
  const masterRef = useRef(null);

  const [showAdd, setShowAdd] = useState(false);
  const [available, setAvailable] = useState([]);
  const [availableQuery, setAvailableQuery] = useState("");
  const [selectedAvailableIds, setSelectedAvailableIds] = useState(() => new Set());
  const onChangedRef = useRef(onChanged);

  const scheduleId = schedule?.id;

  useEffect(() => {
    onChangedRef.current = onChanged;
  }, [onChanged]);

  const refreshStudents = useCallback(async () => {
    if (!scheduleId) return [];
    setLoading(true);
    setError("");
    try {
      const list = (await fetchExamStudents(scheduleId)) || [];
      setStudents(Array.isArray(list) ? list : []);
      setSelectedIds(new Set());
      onChangedRef.current?.({ students: Array.isArray(list) ? list : [], scheduleId });
      return list;
    } catch (err) {
      setError(err?.message || "No se pudieron cargar estudiantes");
      return [];
    } finally {
      setLoading(false);
    }
  }, [fetchExamStudents, scheduleId]);

  useEffect(() => {
    if (!open || !scheduleId) return;
    setQuery("");
    setShowAdd(false);
    setAvailable([]);
    setAvailableQuery("");
    setSelectedAvailableIds(new Set());
    refreshStudents();
  }, [open, refreshStudents, scheduleId]);

  const filteredStudents = useMemo(() => {
    const q = normalizeText(query);
    if (!q) return students;
    return students.filter((s) =>
      normalizeText(`${s?.nombres || ""} ${s?.apellidos || ""} ${s?.nombre || ""} ${s?.email || ""} ${s?.codigo_institucional || ""}`).includes(q)
    );
  }, [query, students]);

  const filteredAvailable = useMemo(() => {
    const q = normalizeText(availableQuery);
    if (!q) return available;
    return available.filter((s) =>
      normalizeText(`${s?.nombres || ""} ${s?.apellidos || ""} ${s?.nombre || ""} ${s?.email || ""} ${s?.codigo_institucional || ""}`).includes(q)
    );
  }, [available, availableQuery]);

  const studentIdsOnPage = useMemo(() => filteredStudents.map((s) => Number(s.id)), [filteredStudents]);
  const allSelected = studentIdsOnPage.length > 0 && studentIdsOnPage.every((id) => selectedIds.has(id));
  const someSelected = studentIdsOnPage.some((id) => selectedIds.has(id));

  useEffect(() => {
    if (masterRef.current) masterRef.current.indeterminate = !allSelected && someSelected;
  }, [allSelected, someSelected]);

  const markBusy = useCallback((id, busy) => {
    setStudentBusy((prev) => {
      const next = new Set(prev);
      if (busy) next.add(id);
      else next.delete(id);
      return next;
    });
  }, []);

  const toggleAll = useCallback(() => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (allSelected) studentIdsOnPage.forEach((id) => next.delete(id));
      else studentIdsOnPage.forEach((id) => next.add(id));
      return next;
    });
  }, [allSelected, studentIdsOnPage]);

  const toggleOne = useCallback((id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const occupied = Number(schedule?.cupos_ocupados || schedule?.estudiantes_agendados || students.length || 0);
  const capacity = Number(schedule?.cupos_disponibles || 0);
  const remainingSlots = capacity > 0 ? Math.max(0, capacity - occupied) : 9999;
  const addAllowed = canAddStudentsFor({ ...schedule, cupos_ocupados: occupied });

  const openAddPanel = useCallback(async () => {
    if (!addAllowed) return;
    setShowAdd(true);
    setLoading(true);
    setError("");
    try {
      const list = (await fetchAvailableStudents(scheduleId)) || [];
      setAvailable(Array.isArray(list) ? list : []);
      setSelectedAvailableIds(new Set());
      setAvailableQuery("");
    } catch (err) {
      setError(err?.message || "No se pudieron cargar estudiantes disponibles");
    } finally {
      setLoading(false);
    }
  }, [addAllowed, fetchAvailableStudents, scheduleId]);

  const toggleAvailable = useCallback((id) => {
    setSelectedAvailableIds((prev) => {
      const next = new Set(prev);
      if (next.has(String(id))) next.delete(String(id));
      else if (next.size < remainingSlots) next.add(String(id));
      return next;
    });
  }, [remainingSlots]);

  const addSelected = useCallback(async () => {
    const ids = Array.from(selectedAvailableIds);
    if (!ids.length || !scheduleId) return;
    const toAdd = ids.slice(0, remainingSlots);
    setLoading(true);
    try {
      const results = await runPool(toAdd, (studentId) => addStudentToExam(scheduleId, studentId), 4);
      const failed = results.filter((r) => !r.ok);
      await refreshStudents();
      setShowAdd(false);
      setAvailable([]);
      setSelectedAvailableIds(new Set());
      if (failed.length) alert(`Se agregaron ${results.length - failed.length} estudiante(s), pero fallaron ${failed.length}.`);
    } catch (err) {
      setError(err?.message || "No se pudieron agregar estudiantes");
    } finally {
      setLoading(false);
    }
  }, [addStudentToExam, refreshStudents, remainingSlots, scheduleId, selectedAvailableIds]);

  const removeStudent = useCallback(async (studentId) => {
    if (!window.confirm("¿Remover este estudiante?")) return;
    setLoading(true);
    try {
      await removeStudentFromExam(scheduleId, studentId);
      await refreshStudents();
    } catch (err) {
      setError(err?.message || "No se pudo remover estudiante");
    } finally {
      setLoading(false);
    }
  }, [refreshStudents, removeStudentFromExam, scheduleId]);

  const toggleEnable = useCallback(async (studentId, nextEnabled) => {
    const previous = students.find((s) => Number(s.id) === Number(studentId));
    if (!previous) return;
    markBusy(studentId, true);
    setStudents((prev) => prev.map((s) => Number(s.id) === Number(studentId) ? { ...s, habilitado: !!nextEnabled } : s));
    try {
      await setStudentExamEnabled(scheduleId, studentId, nextEnabled, user?.id);
    } catch (err) {
      setStudents((prev) => prev.map((s) => Number(s.id) === Number(studentId) ? previous : s));
      setError(err?.message || "No se pudo actualizar habilitación");
    } finally {
      markBusy(studentId, false);
    }
  }, [markBusy, scheduleId, setStudentExamEnabled, students, user?.id]);

  const bulkEnable = useCallback(async (nextEnabled) => {
    const ids = Array.from(selectedIds);
    if (!ids.length || !scheduleId) return;
    setLoading(true);
    try {
      const results = await runPool(ids, (studentId) => setStudentExamEnabled(scheduleId, studentId, nextEnabled, user?.id), 4);
      const okIds = results.filter((r) => r.ok).map((r) => Number(r.item));
      setStudents((prev) => prev.map((s) => okIds.includes(Number(s.id)) ? { ...s, habilitado: !!nextEnabled } : s));
      setSelectedIds(new Set());
      const failed = results.filter((r) => !r.ok);
      if (failed.length) alert(`Se actualizaron ${okIds.length} estudiante(s), pero fallaron ${failed.length}.`);
    } catch (err) {
      setError(err?.message || "No se pudo actualizar la habilitación masiva");
    } finally {
      setLoading(false);
    }
  }, [scheduleId, selectedIds, setStudentExamEnabled, user?.id]);

  const downloadCsv = useCallback(() => {
    const rows = students.map((s) => ({
      nombre: getStudentDisplayName(s),
      email: s?.email || "",
      codigo: s?.codigo_institucional || "",
      agendado: formatStudentEnrollDate(s?.fecha_agendamiento || s?.fecha_inscripcion || s?.created_at),
      acceso: s?.habilitado ? "Habilitado" : "Inhabilitado",
    }));
    const header = ["Nombre", "Email", "Código", "Agendado", "Acceso"];
    const csv = [
      header.join(","),
      ...rows.map((r) =>
        [r.nombre, r.email, r.codigo, r.agendado, r.acceso]
          .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
          .join(",")
      ),
    ].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `horario-${schedule?.codigo_horario || scheduleId || "estudiantes"}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }, [schedule?.codigo_horario, scheduleId, students]);

  if (!open || !schedule) return null;

  return (
    <div className="essm-overlay">
      <style>{styles}</style>
      <div className="essm-modal">
        <div className="essm-head">
          <div className="essm-top">
            <div className="essm-titleWrap">
              <div className="essm-icon"><Users size={22} /></div>
              <div>
                <h2 className="essm-title">{title}</h2>
                <div className="essm-meta">
                  <span>{String(schedule?.fecha_examen || "").slice(0, 10) || "Sin fecha"}</span>
                  <span className="essm-chip">{formatTimeShort(schedule?.hora_inicio)} - {formatTimeShort(schedule?.hora_fin)}</span>
                </div>
              </div>
            </div>
            <div className="essm-actions">
              <span className="essm-chip">Cupos usados: {occupied} / {capacity || "sin límite"}</span>
              <button type="button" className="essm-close" onClick={onClose} title="Cerrar">×</button>
            </div>
          </div>
        </div>

        <div className="essm-toolbar">
          <div className="essm-search">
            <Search size={16} className="essm-searchIcon" />
            <input className="essm-input" placeholder="Buscar por cédula, nombre o correo..." value={query} onChange={(e) => setQuery(e.target.value)} />
          </div>
          <div className="essm-actions">
            <button type="button" className="essm-btn" disabled={loading || !students.length} onClick={downloadCsv}>
              <FileText size={15} /> Descargar
            </button>
            <button type="button" className="essm-btn primary" disabled={loading || !addAllowed} onClick={openAddPanel}>
              <Users size={15} /> Inscribir
            </button>
          </div>
        </div>

        {error && <div className="essm-note" style={{ margin: "12px 20px 0", color: "#b91c1c", background: "#fff5f5", borderColor: "#fecaca" }}>{error}</div>}

        {showAdd && (
          <div className="essm-addPanel">
            <div className="essm-note">Cupos disponibles: {remainingSlots === 9999 ? "sin límite" : remainingSlots}</div>
            <div className="essm-search">
              <Search size={16} className="essm-searchIcon" />
              <input className="essm-input" placeholder="Buscar estudiante por nombre o correo..." value={availableQuery} onChange={(e) => setAvailableQuery(e.target.value)} />
            </div>
            {selectedAvailableIds.size > 0 && (
              <div className="essm-picks">
                {available.filter((s) => selectedAvailableIds.has(String(s.id))).map((s) => (
                  <span key={s.id} className="essm-pill">
                    {getStudentDisplayName(s)}
                    <button type="button" onClick={() => toggleAvailable(s.id)}>×</button>
                  </span>
                ))}
              </div>
            )}
            <div className="essm-available">
              {loading ? (
                <LoadingSpinner />
              ) : filteredAvailable.length ? filteredAvailable.map((s) => {
                const selected = selectedAvailableIds.has(String(s.id));
                const disabled = !selected && selectedAvailableIds.size >= remainingSlots;
                return (
                  <button key={s.id} type="button" className="essm-option" disabled={disabled} onClick={() => toggleAvailable(s.id)}>
                    <span className="essm-optionLeft">
                      <input type="checkbox" checked={selected} readOnly />
                      <span className="essm-avatar">{getInitials(s)}</span>
                      <span>
                        <div className="essm-name">{getStudentDisplayName(s)}</div>
                        <div className="essm-sub">{s?.email || "Sin correo"}</div>
                      </span>
                    </span>
                    <span className="essm-chip">{selected ? "Seleccionado" : disabled ? "Sin cupos" : "Elegir"}</span>
                  </button>
                );
              }) : (
                <div className="essm-empty">No hay estudiantes disponibles.</div>
              )}
            </div>
            <div className="essm-actions" style={{ justifyContent: "flex-end" }}>
              <button type="button" className="essm-btn" onClick={() => { setShowAdd(false); setSelectedAvailableIds(new Set()); }}>Cancelar</button>
              <button type="button" className="essm-btn primary" disabled={!selectedAvailableIds.size || loading || remainingSlots <= 0} onClick={addSelected}>
                Agregar {Math.min(selectedAvailableIds.size, remainingSlots)} estudiante(s)
              </button>
            </div>
          </div>
        )}

        <div className="essm-body">
          {selectedIds.size > 0 && (
            <div className="essm-bulk">
              <button type="button" className="essm-btn" disabled={loading} onClick={() => bulkEnable(true)}>Habilitar seleccionados</button>
              <button type="button" className="essm-btn" disabled={loading} onClick={() => bulkEnable(false)}>Inhabilitar seleccionados</button>
            </div>
          )}

          {loading && !showAdd ? (
            <div style={{ padding: 30, display: "flex", justifyContent: "center" }}><LoadingSpinner /></div>
          ) : !filteredStudents.length ? (
            <div className="essm-empty">No hay estudiantes agendados en este horario.</div>
          ) : (
            <div className="essm-tableWrap">
              <table className="essm-table">
                <thead>
                  <tr>
                    <th><input ref={masterRef} type="checkbox" checked={allSelected} onChange={toggleAll} /></th>
                    <th>Estudiante</th>
                    <th>Agendamiento</th>
                    <th>Matriculación</th>
                    <th>Acceso</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredStudents.map((s) => {
                    const busy = studentBusy.has(s.id);
                    return (
                      <tr key={s.id}>
                        <td><input type="checkbox" checked={selectedIds.has(Number(s.id))} onChange={() => toggleOne(Number(s.id))} disabled={busy} /></td>
                        <td>
                          <div className="essm-student">
                            <span className="essm-avatar">{getInitials(s)}</span>
                            <span>
                              <div className="essm-name">{getStudentDisplayName(s)}</div>
                              <div className="essm-sub">{s?.email || "Sin correo"}</div>
                              <div className="essm-doc">C.I. {s?.codigo_institucional || "--"}</div>
                            </span>
                          </div>
                        </td>
                        <td><span className="essm-date">{formatStudentEnrollDate(s?.fecha_agendamiento || s?.fecha_inscripcion || s?.created_at)}</span></td>
                        <td><span className="essm-origin">{s?.origen_matricula || s?.origen || "Directa"}</span></td>
                        <td>
                          <button type="button" className={`essm-switch ${s?.habilitado ? "on" : ""}`} disabled={busy} onClick={() => toggleEnable(Number(s.id), !s?.habilitado)}>
                            <span className="essm-thumb" />
                          </button>
                        </td>
                        <td>
                          <button type="button" className="essm-iconBtn" disabled={busy} onClick={() => removeStudent(Number(s.id))} title="Eliminar estudiante del horario">
                            <Trash2 size={15} />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="essm-foot">
          <div className="essm-actions">
            <span>Mostrar</span>
            <select className="essm-select" value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
              {PAGE_SIZE_OPTIONS.map((n) => <option key={n} value={n}>{n}</option>)}
            </select>
            <span>registros</span>
          </div>
          <div className="essm-actions">
            <span>Página 1 de 1</span>
            <span className="essm-btn"><ChevronLeft size={14} /></span>
            <span className="essm-btn"><ChevronRight size={14} /></span>
          </div>
        </div>
      </div>
    </div>
  );
}
